import { CommanderThunkAction } from '@mews-commander/types';
import { replace } from '@mews/routing';
import { getPathFromUrl } from '@mews-commander/utils';
import { getOwnerSortedFilesIds } from '@mews-commander/legacy-entities/src/ducks/files';
import { getSortedAddressIdsByOwnerId, getCustomerIdsByCompanyId } from '@mews-commander/legacy-entities/src/ducks';
import { createPagination } from '../../pagination/actions';
import { CompanyDetailTabs } from '../enums';

export const CONTRACT_FILES_PAGE_SIZE = 10;
export const ADDRESSES_PAGE_SIZE = 3;
export const CONTACTS_PAGE_SIZE = 10;
const FILES_PAGE_SIZE = 5;

export const createContractFilesPagination =
    (ownerId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const ids = getOwnerSortedFilesIds(getState(), { ownerId });
        return dispatch(createPagination(ids, CONTRACT_FILES_PAGE_SIZE, `company-contracts-${scope}`));
    };

export const createAddressPagination =
    (companyId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const ids = getSortedAddressIdsByOwnerId(getState(), { ownerId: companyId });
        return dispatch(createPagination(ids, ADDRESSES_PAGE_SIZE, `company-addresses-${scope}`));
    };

export const createFilesPagination =
    (ownerId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const ids = getOwnerSortedFilesIds(getState(), { ownerId });
        return dispatch(createPagination(ids, FILES_PAGE_SIZE, `files-${scope}`));
    };

export const createContactsPagination =
    (companyId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const ids = getCustomerIdsByCompanyId(getState(), { companyId });
        return dispatch(createPagination(ids, CONTACTS_PAGE_SIZE, `company-contacts-${scope}`));
    };

export const paginationTabChange =
    (valueTab: CompanyDetailTabs, companyId: string, scope: string): CommanderThunkAction =>
    (dispatch) => {
        switch (valueTab) {
            case CompanyDetailTabs.Details:
                dispatch(createAddressPagination(companyId, scope));
                dispatch(createFilesPagination(companyId, scope));
                break;
            case CompanyDetailTabs.Contract:
                dispatch(createContractFilesPagination(companyId, scope));
                break;
            case CompanyDetailTabs.RelatedContacts:
                dispatch(createContactsPagination(companyId, scope));
                break;
            default:
                break;
        }
    };

export const changeTab =
    (valueTab: CompanyDetailTabs): CommanderThunkAction =>
    (dispatch) => {
        const url = new URL(global.location.href);

        if (valueTab !== CompanyDetailTabs.Billing) {
            url.searchParams.delete('billId');
        }

        if (valueTab !== CompanyDetailTabs.Payments) {
            url.searchParams.delete('activeSegment');
        }

        url.searchParams.set('tab', valueTab);

        dispatch(replace(getPathFromUrl(url, true)));
    };
